import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Typography, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";


const ServicesOverviewPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();


    return (

        <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
        >
            <Container maxWidth="md" sx={{ py: 5 }}>
                <Typography
                    variant="h4"
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                        display: 'inline-block',
                        pb: 1,
                        mb: 4
                    }}
                >
                    {t("servicesoverview.title")}
                </Typography>

                <Box // Service
                    sx={{
                        mb: 4,
                        p: 2,
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: '0.2s',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0 0 8px rgba(198,160,76,0.4)'
                        }
                    }}
                    onClick={() => navigate('/services')}  
                >
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {t("servicesoverview.servicesTitle")}
                    </Typography>
                    <Typography>{t("servicesoverview.servicesText")}</Typography>
                </Box>

                <Box // Webbdesign
                    sx={{
                        mb: 4,
                        p: 2,
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: '0.2s',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0 0 8px rgba(198,160,76,0.4)'
                        }
                    }}
                    onClick={() => navigate('/webdesign')}  
                >
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {t("servicesoverview.webbdesignTitle")}
                    </Typography>
                    <Typography>{t("servicesoverview.webbdesignText")}</Typography>
                </Box>

                <Box // Översättning och myndighet
                    sx={{
                        mb: 4,
                        p: 2,
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: '0.2s',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0 0 8px rgba(198,160,76,0.4)'
                        }
                    }}
                    onClick={() => navigate('/legal')}  
                >
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {t("servicesoverview.documentsTitle")}
                    </Typography>
                    <Typography>{t("servicesoverview.documentsText")}</Typography>
                </Box>

                <Box // Rådgivning och information
                    sx={{
                        mb: 4,
                        p: 2,
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: '0.2s',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0 0 8px rgba(198,160,76,0.4)'
                        }
                    }}
                    onClick={() => navigate('/info')}  
                >
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {t("servicesoverview.infopageTitle")}
                    </Typography>
                    <Typography>{t("servicesoverview.infopageText")}</Typography>
                </Box>

            </Container>
        </motion.div>
    );
};

export default ServicesOverviewPage;
